<p>Hangjegyzetek:</p>
<p *ngFor="let item of soundList;">
    <span>
        <audio controls>
            <source [src]="soundUrl(item)" type="audio/x-m4a">
        </audio>
    </span>
    <span>
        <button (click)="delSound(item)">Törlés</button>
    </span>
</p>
<app-upload-ticket-file 
    fileType="audio"
    [ticket]="instance"
    [refresh]="refresh"
>
</app-upload-ticket-file>